import LegalPage, { LegalSection } from '../components/LegalPage';
import { SITE } from '../lib/site';

const TerminosCondiciones = () => {
  return (
    <LegalPage title="Términos y Condiciones" updated="Actualizado: agosto de 2026" url="/terminos-y-condiciones">
      <LegalSection title="1. Aceptación de los términos">
        <p>
          El acceso y uso de este sitio web atribuye la condición de usuario e implica la
          aceptación plena de los presentes términos y condiciones. Si no estás de acuerdo
          con ellos, te pedimos que no utilices el sitio.
        </p>
      </LegalSection>
      <LegalSection title="2. Servicios ofrecidos">
        <p>
          HGO Servicios ofrece servicios de construcción, reformas integrales y parciales,
          obra nueva, rehabilitación, reformas comerciales y mantenimiento de comunidades
          en Málaga y la Costa del Sol. La información publicada en este sitio (incluidos
          precios orientativos, plazos y fotografías) tiene carácter informativo y no
          constituye oferta contractual.
        </p>
        <p>
          Las condiciones definitivas de cada proyecto (precio, plazos, garantías,
          forma de pago) se recogen en el presupuesto y contrato firmado por ambas partes,
          que prevalece sobre cualquier información de esta web.
        </p>
      </LegalSection>
      <LegalSection title="3. Solicitudes de presupuesto">
        <p>
          Al enviar una solicitud de presupuesto, te comprometes a facilitar información
          veraz. HGO Servicios se reserva el derecho de no ofertar trabajos para los que
          no disponga de capacidad de ejecución en el plazo requerido.
        </p>
      </LegalSection>
      <LegalSection title="4. Propiedad intelectual y uso del contenido">
        <p>
          Las fotografías de obras publicadas son propiedad de HGO Servicios y de sus
          clientes, y no pueden utilizarse con fines comerciales sin autorización escrita.
          Está prohibido copiar, reproducir o distribuir los contenidos de esta web sin
          consentimiento previo.
        </p>
      </LegalSection>
      <LegalSection title="5. Responsabilidad">
        <p>
          HGO Servicios no garantiza la disponibilidad ininterrumpida del sitio web ni la
          ausencia de errores, y no será responsable de los daños derivados de
          indisponibilidades temporales o del uso indebido de la información publicada.
        </p>
      </LegalSection>
      <LegalSection title="6. Modificaciones">
        <p>
          HGO Servicios puede actualizar estos términos en cualquier momento. La versión
          vigente será la publicada en esta página, por lo que te recomendamos revisarla
          periódicamente.
        </p>
      </LegalSection>
      <LegalSection title="7. Legislación aplicable">
        <p>
          Estos términos se rigen por la legislación española. Para cualquier controversia,
          las partes se someten a los juzgados y tribunales de Málaga.
        </p>
      </LegalSection>
    </LegalPage>
  );
};

export default TerminosCondiciones;
